import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import {useApolloClient, useQuery} from '@apollo/client';
import { useAddProductToCart } from '../hooks/useAddProductToCart';
import { useUpdateCartItem } from '../hooks/useUpdateCartItem';
import {ADD_PRODUCT_TO_CART, GET_CART, RESERVE_ORDER_ID} from '../queries/cart';
import { METHOD_MATRIX } from '../utils/checkout';
import { useReservedOrderId } from '../hooks/useReserveOrderId';
import useCartMutation from "../hooks/useCartMutation";
const CartContext = createContext(null);

export const CartConsumer = CartContext.Consumer;

export const useCartContext = () => {
    return useContext(CartContext);
};

export const defaultCart = {
    'items': [],
    'prices': {
        'grand_total': 0
    }
}

export const CartContextProvider = ({children}) => {

    const getCartResult = useQuery(GET_CART, {
        fetchPolicy: 'network-only',
        ssr: false
    });

    const [cart, setCart] = useState()
    const [method, setMethod] = useState(METHOD_MATRIX);

    useEffect(() => {
        if (getCartResult.data) {
            setCart(getCartResult.data.cart);
        }
    }, [getCartResult.data]);

    const [addProductToCart, addProductResult] = useAddProductToCart();

    const [updateCartItems, updateCartResult] = useUpdateCartItem();
    const [phoneNumber, setPhoneNumber] = useState('');
    const [orderNote, setOrderNote] = useState('');

    const loading = getCartResult.loading || addProductResult.loading || updateCartResult.loading;
    const updateCartItem = (id, quantity) =>{
        updateCartItems([{cart_item_id: +id, quantity}])
    }

    const address = cart && cart.shipping_addresses && cart.shipping_addresses[0];
    const currentMethod = address && address.selected_shipping_method && address.selected_shipping_method.carrier_code;

    const resetCart=()=>{
        setCart(defaultCart)
    }
    useEffect(() => {
        if (address && currentMethod) {
            setMethod(currentMethod);
        }
    }, [currentMethod]);



    // Dodawanie produktu do koszyka
    const handleProductAdd = (sku, quantity) => {
        const itemInCart = false;

        if (cart) {
            cart.items.find(item => item.product.sku === sku);
        }

        if (itemInCart) {
            return updateCartItem(itemInCart.id, itemInCart.quantity + quantity);
        }

        return addProductToCart(sku, quantity);
    };

    const reserveOrderId = useReservedOrderId();
    const generateReservedId = async () => {
        try {
            if (cart && cart.reserved_order_id && cart.reserved_order_id.trim() !== '') {
                return cart.reserved_order_id;
            }

            // Wywołaj funkcję, aby zarezerwować ID zamówienia
            const orderId = await reserveOrderId();
            return orderId
            // Możesz użyć orderId w dalszej logice, np. zapisać w stanie lub wyświetlić użytkownikowi
        } catch (error) {

        }
    };

    return (
        <CartContext.Provider
            value={{
                cart,
                method,
                setMethod,
                phoneNumber,
                setPhoneNumber,
                orderNote,
                setOrderNote,
                refetchCart: () => getCartResult.refetch(),
                cartStatus: getCartResult.networkStatus,
                loading,
                handleProductAdd,
                updateCartItem,
                updateCartItems,
                resetCart,
                generateReservedId
            }}
        >
            {children}
        </CartContext.Provider>
    );
};
